import { render, staticRenderFns } from "./WebhotelDetail.vue?vue&type=template&id=1be6c9ea"
import script from "./WebhotelDetail.vue?vue&type=script&lang=js"
export * from "./WebhotelDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports